import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=47623850&scoped=true&"
import script from "./Budget.vue?vue&type=script&lang=ts&"
export * from "./Budget.vue?vue&type=script&lang=ts&"
import style0 from "./Budget.vue?vue&type=style&index=0&id=47623850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47623850",
  null
  
)

export default component.exports